<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12 col-md-12 col-lg">
          <h1 class="text-white pt-3 px-3">หน้าจัดการร้านค้า</h1>
          <p class="text-white pb-3 px-3">
            เพิ่ม แก้ไข ลบร้านค้า และแสดงตารางรายละเอียดร้านค้าทั้งหมดที่มีอยู่
          </p>
        </div>
        <div class="col-12 col-md-12 col-lg-4 text-right">
          <div
            v-b-modal.modalAddBrance
            class="btn btn-outline-light btn-icon btn-icon-add py-3"
            role="button">
            <i class="fas fa-plus"></i>
            <p>เพิ่มร้านค้า</p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col-12 d-flex align-self-center">
                  <h3 class="text-muted">ตารางแสดงรายละเอียดร้านค้าทั้งหมด</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-lg">
                      <b-input-group>
                        <b-form-input
                          v-model="filter.name"
                          placeholder="ค้นหาชื่อร้านค้า"></b-form-input>
                      </b-input-group>
                    </div>
                    <div class="col-lg">
                      <b-input-group>
                        <b-form-input
                          v-model="filter.owner_name"
                          placeholder="ค้นหาชื่อเจ้าของร้าน"></b-form-input>
                      </b-input-group>
                    </div>
                    <div class="col-lg">
                      <b-input-group>
                        <b-form-input
                          v-model="filter.tel"
                          placeholder="ค้นหาเบอร์โทรศัพท์"></b-form-input>
                      </b-input-group>
                    </div>
                    <div class="col-lg">
                      <b-input-group>
                        <b-form-input
                          v-model="filter.email"
                          placeholder="ค้นหาอีเมล์"></b-form-input>
                      </b-input-group>
                    </div>
                  </div>
                  <div class="col-12 pt-2">
                    <div class="row">
                      <div class="col d-flex justify-content-end">
                        <button
                          class="btn btn-info btn-sm-res"
                          @click="getDataBrance()"
                          :disabled="filter.error">
                          <i class="fa fa-search"></i>
                        </button>
                        <!-- <button class="btn btn-danger btn-sm-res" @click="resetFilter()">
                          เคลียค่า
                        </button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <b-tabs active-nav-item-class="text-info">
                <b-tab
                  v-for="tab in tabTitle"
                  :key="tab.key"
                  @click="tabKey = tab.key">
                  <template v-slot:title>
                    <div class="mx-3">{{ tab.name }}</div>
                  </template>
                  <div id="tablePrint">
                    <TableBrancePersonal
                      v-if="tab.key == 'personal'"
                      :busy.sync="busy"
                      :personal="personal"
                      @showComfirmModal="showComfirmModal($event)" />
                    <TableBranceUpgrade
                      v-if="tab.key == 'brance'"
                      :busy.sync="busy"
                      :brance="brances"
                      @statusChange="statusChange"
                      @showComfirmModal="showComfirmModal($event)" />
                    <TableBranceArea
                      v-if="tab.key == 'area'"
                      :busy.sync="busy"
                      :area="area"
                      @showComfirmModal="showComfirmModal($event)" />
                    <TableBranceImages
                      v-if="tab.key == 'images'"
                      :busy.sync="busy"
                      :images="images"
                      @updateTierShop="updateTierShop"
                      @showComfirmModal="showComfirmModal($event)" />
                    <TableBranceOther
                      v-if="tab.key == 'other'"
                      :busy.sync="busy"
                      :other="other"
                      @showComfirmModal="showComfirmModal($event)" />
                  </div>
                </b-tab>
              </b-tabs>
              <div class="mt-3">
                <b-pagination
                  :total-rows="pagination.totalItem"
                  :current-page="pagination.page"
                  :per-page="50"
                  :value="pagination.page"
                  @input="changePage"
                  align="right">
                </b-pagination>
                <!-- nuttakorn -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modalAddBrance"
      ref="addBrance"
      hide-footer
      title="แบบฟอร์มรายละเอียดร้านค้า"
      @hide="submittAdd = false">
      <form @submit.prevent="addBrance()">
        <card shadow type="secondary" class="m--4">
          <template>
            <h6 class="heading-small text-muted mb-4">รายละเอียดร้านค้า</h6>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>
                    <span class="text-danger">*</span> ชื่อเจ้าของ
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="ชื่อเจ้าของ"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.owner_name.$error,
                    }"
                    v-model="brance.owner_name" />
                  <!-- vuelidate -->
                  <label
                    class="error invalid-feedback"
                    v-if="!$v.brance.owner_name.minLength"
                    >กรุณากรอก"ชื่อเจ้าของ"อย่างน้อย
                    {{ $v.brance.owner_name.$params.minLength.min }}
                    ตัวอักษร</label
                  >
                  <label
                    v-if="submittAdd && !$v.brance.owner_name.required"
                    class="invalid-feedback"
                    >กรุณากรอกชื่อเจ้าของ</label
                  >
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>
                    <span class="text-danger">*</span> หมายเลขโทรศัพท์ร้านค้า
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="หมายเลยโทรศัพท์ร้านค้า"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.tel.$error,
                    }"
                    v-model="brance.tel" />
                  <!-- vuelidate -->
                  <label
                    v-if="submittAdd && !$v.brance.tel.required"
                    class="invalid-feedback"
                    >กรุณากรอกเบอร์โทรศัพท์</label
                  >
                  <label
                    class="error invalid-feedback"
                    v-if="!$v.brance.tel.minLength"
                    >กรุณากรอก"เบอร์โทรศัพท์"อย่างน้อย
                    {{ $v.brance.tel.$params.minLength.min }}ตัวเลข</label
                  >
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label>
                    <span class="text-danger">*</span> ชื่อร้านค้า
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="ชื่อร้านค้า"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.name.$error,
                    }"
                    v-model="brance.name" />
                  <!-- vuelidate -->
                  <label
                    class="error invalid-feedback"
                    v-if="!$v.brance.name.minLength"
                    >กรุณากรอก"ชื่อร้านค้า"อย่างน้อย
                    {{ $v.brance.name.$params.minLength.min }} ตัวอักษร</label
                  >
                  <label
                    v-if="submittAdd && !$v.brance.name.required"
                    class="invalid-feedback"
                    >กรุณากรอกชื่อร้านค้า</label
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label>
                    <span class="text-danger">*</span> สถานที่ตั้งร้านค้า
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="สถานที่ตั้งร้านค้า"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.address.$error,
                    }"
                    v-model="brance.address" />
                  <!-- vuelidate -->
                  <label
                    class="error invalid-feedback"
                    v-if="!$v.brance.address.minLength"
                    >กรุณากรอก"สถานที่ตั้ง"อย่างน้อย
                    {{ $v.brance.address.$params.minLength.min }}
                    ตัวอักษร</label
                  >
                  <label
                    v-if="submittAdd && !$v.brance.address.required"
                    class="invalid-feedback"
                    >กรุณากรอกสถานที่ตั้ง</label
                  >
                </div>
              </div>
              <!-- ตำบล -->
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <addressinput-subdistrict
                    :store="storeto"
                    v-model="brance.state"
                    class="form-control"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.state.$error,
                    }" />
                  <!-- vuelidate -->
                  <div
                    v-if="submittAdd && !$v.brance.state.required"
                    class="invalid-th-address">
                    กรุณากรอกตำบล/แขวง
                  </div>
                </div>
              </div>
              <!-- อำเภอ -->
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <addressinput-district
                    :store="storeto"
                    v-model="brance.district"
                    class="form-control"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.district.$error,
                    }" />
                  <!-- vuelidate -->
                  <div
                    v-if="submittAdd && !$v.brance.district.required"
                    class="invalid-th-address">
                    กรุณากรอกอำเภอ/เขต
                  </div>
                </div>
              </div>
              <!-- จังหวัด -->
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <addressinput-province
                    :store="storeto"
                    v-model="brance.province"
                    class="form-control"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.province.$error,
                    }" />
                  <!-- vuelidate -->
                  <div
                    v-if="submittAdd && !$v.brance.province.required"
                    class="invalid-th-address">
                    กรุณากรอกจังหวัด
                  </div>
                </div>
              </div>
              <!-- รหัสไปรษณีย์ -->
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <addressinput-zipcode
                    :store="storeto"
                    v-model="brance.postcode"
                    class="form-control"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.postcode.$error,
                    }" />
                  <!-- vuelidate -->
                  <div
                    v-if="submittAdd && !$v.brance.postcode.required"
                    class="invalid-th-address">
                    กรุณากรอกรหัสไปรษณีย์
                  </div>

                  <div
                    class="error invalid-th-address"
                    v-if="submittAdd && !$v.brance.postcode.minLength">
                    กรุณากรอก"รหัสไปรษณีย์"
                    {{ $v.brance.postcode.$params.minLength.min }} หลัก
                  </div>

                  <div
                    class="error invalid-th-address"
                    v-if="submittAdd && !$v.brance.postcode.maxLength">
                    กรุณากรอก"รหัสไปรษณีย์"
                    {{ $v.brance.postcode.$params.maxLength.max }} หลัก
                  </div>

                  <div
                    class="error invalid-th-address"
                    v-if="submittAdd && !$v.brance.postcode.numeric">
                    กรุณากรอกเฉพาะตัวเลข
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label floater>เลขประจำตัวผู้เสียภาษี</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="brance.tax_shop"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.tax_shop.$error,
                    }" />
                  <div
                    class="error invalid-feedback"
                    v-if="submittAdd && !$v.brance.tax_shop.numeric">
                    กรุณากรอกเฉพาะตัวเลข
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-4" />
            <!-- Address -->
            <h6 class="heading-small text-muted mb-4">ส่วนเข้าสู่ระบบ</h6>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label> <span class="text-danger">*</span> E-mail </label>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="E-mail"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.email.$error,
                    }"
                    v-model="brance.email" />
                  <div
                    v-if="submittAdd && $v.brance.email.$error"
                    class="invalid-feedback">
                    <span v-if="!$v.brance.email.required"
                      >กรุณากรอกอีเมล์</span
                    >
                    <span v-if="!$v.brance.email.email"
                      >รูปแบบอีเมล์ไม่ถูกต้อง</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label> <span class="text-danger">*</span> Password </label>
                  <input
                    type="password"
                    class="form-control"
                    placeholder="Password"
                    :class="{
                      'is-invalid': submittAdd && $v.brance.password.$error,
                    }"
                    v-model="brance.password" />
                  <div
                    v-if="submittAdd && $v.brance.password.$error"
                    class="invalid-feedback">
                    <span v-if="!$v.brance.password.required"
                      >กรุณากรอกรหัสผ่าน</span
                    >
                    <span v-if="!$v.brance.password.minLength"
                      >กรุณากรอก"รหัสผ่าน"อย่างน้อย
                      {{ $v.brance.password.$params.minLength.min }}
                      ตัวอักษร</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </template>
        </card>
        <div slot="modal-footer" class="w-100 text-right pt-5">
          <b-button
            variant="secondary"
            @click="
              $bvModal.hide('modalAddBrance'),
                (submittAdd = false),
                clearTextInModalAddBrance()
            "
            >ยกเลิก</b-button
          >
          <b-button variant="success" type="submit">ยืนยัน</b-button>
        </div>
      </form>
    </b-modal>
    <ModalNotification :notiShop="noti" />
  </div>
</template>
<script>
import validatePop from "../plugins/validatePop.js";
import ModalNotification from "@/components/custom/ModalNotification";
import InputShopCode from "@/components/custom/BaseInput/ShopCode";
import { DataStore } from "vue-thailand-address";
import moment from "moment";
import {
  required,
  requiredIf,
  email,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import TableBrancePersonal from "@/components/custom/branceNew/TableBrancePersonal";
import TableBranceUpgrade from "@/components/custom/branceNew/TableBranceUpgrade";
import TableBranceArea from "@/components/custom/branceNew/TableBranceArea";
import TableBranceImages from "@/components/custom/branceNew/TableBranceImages";
import TableBranceOther from "@/components/custom/branceNew/TableBranceOther";
import ExportExcel from "@/components/custom/exportExcel/ExportExcel";
import { courierList } from "@/plugins/courierName.js";

import {
  dayBrance,
  locationBrance,
  serviceAreaBrance,
  heightBrance,
  rentBrance,
  billboardBrance,
  kitchenBrance,
  sellServiceBrance,
  otherServiceBrance,
  operatingSystemBrance,
  typeCarTHPBrance,
} from "@/plugins/formatForBrance.js";
import configPOPTheme from "@/config/POPTheme";
const API_URL = process.env.VUE_APP_API;

export default {
  name: "brance",
  components: {
    ModalNotification,
    InputShopCode,
    TableBrancePersonal,
    TableBranceUpgrade,
    TableBranceArea,
    TableBranceImages,
    TableBranceOther,
    ExportExcel,
  },
  data() {
    return {
      customTheme: configPOPTheme,
      userLogin: "",
      personal: [],
      brances: [],
      area: [],
      images: [],
      other: [],
      exportExcel: [],
      dayBrance: dayBrance,
      locationBrance: locationBrance,
      serviceAreaBrance: serviceAreaBrance,
      heightBrance: heightBrance,
      rentBrance: rentBrance,
      billboardBrance: billboardBrance,
      kitchenBrance: kitchenBrance,
      sellServiceBrance: sellServiceBrance,
      otherServiceBrance: otherServiceBrance,
      operatingSystemBrance: operatingSystemBrance,
      formatClosedDay: "",
      storeto: new DataStore(),
      submittAdd: false,
      busy: true,
      pagination: {
        page: 1,
        totalItem: 0,
      },
      filter: {
        error: false,
        shop_code: "",
        name: "",
        owner_name: "",
        tel: "",
        api_key: "",
        tier_shop: "",
        courier_code: "",
        email: "",
      },
      selected: null,
      select: null,
      detail_package: configPOPTheme.customShopPackage || [
        { value: "TRIAL", text: "ทดลองใช้ 7 วัน" },
        { value: "1", text: "1 เดือน" },
        { value: "3", text: "3 เดือน" },
        { value: "6", text: "6 เดือน" },
        { value: "12", text: "12 เดือน" },
      ],
      select_package_shop: "POP",
      package_shop: [
        { value: "POP", text: "POP" },
        { value: "POPPLUS", text: "POP+" },
        { value: "POPSHOP", text: "POP-SHOP" },
      ],
      size: [
        { value: "A5", text: "A5" },
        { value: "A4", text: "A4" },
        { value: "A6", text: "A6" },
        { value: "receipt", text: "ใบเสร็จ" },
        { value: "letter", text: "ซองจดหมาย" },
        { value: "letter4x6", text: "ขนาด 4*6" },
        { value: "sticker", text: "ขนาดสติกเกอร์ 8x8 เซนติเมตร" },
        { value: "sticker4x6", text: "ขนาดสติกเกอร์ 4x6 นิ้ว" },
        { value: "paperang", text: "Paperang" },
      ],
      tierShop: [
        { value: "1", text: "Tier 1" },
        { value: "2", text: "Tier 2" },
        { value: "3", text: "Tier 3" },
        { value: "4", text: "Tier 4" },
      ],
      courierList: courierList,
      tabKey: "",
      brance: {
        idBrance: "",
        owner_name: "",
        name: "",
        address: "",
        state: "",
        district: "",
        province: "",
        postcode: "",
        tel: "",
        email: "",
        password: "",
        api_key: "",
        member: "",
        status: true,
        wallet: configPOPTheme.forceUseWallet ? true : false,
        forceUseWallet: configPOPTheme.forceUseWallet ? true : false,
      },
      noti: {
        show: false,
        type: "",
        created_by: "",
        role: "",
        router: false,
      },
    };
  },
  validations: {
    brance: {
      owner_name: { required, minLength: minLength(2) },
      name: { required, minLength: minLength(2) },
      address: { required, minLength: minLength(2) },
      state: { required },
      district: { required },
      province: { required },
      postcode: {
        required,
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(5),
      },
      tel: { required, numeric, minLength: minLength(9) },
      email: { required, email },
      password: { required, minLength: minLength(6) },
      tax_shop: { numeric },
    },
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  mounted() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    if (this.userLogin.role == "superadmin") {
      this.checkStatusShop().then((res) => {
        let status_shop = res.data.data.status_shop;
        let created_by = res.data.data.created_by;
        if (status_shop == "LOCK") {
          this.noti.created_by = created_by;
          this.noti.type = status_shop;
          this.noti.role = this.userLogin.role;
          this.noti.show = true;
        }
      });
    }
    this.getDataBrance();
  },
  computed: {
    isShippop() {
      if (this.userLogin.role == "superadmin") {
        this.select_package_shop = "POPSHOP";
      }
      return this.userLogin.role == "shippop";
    },
    isVisible() {
      return this.userLogin.role == "shippop" ? true : false;
    },
    fields() {
      let fields = [
        { key: "shop_code", label: "รหัสร้าน", sortable: true },
        { key: "under_by", label: "สร้างโดย", sortable: true },
        { key: "name", label: "ชื่อสาขา", sortable: true },
        { key: "owner_name", label: "ชื่อเจ้าของ", sortable: true },
        { key: "num_of_user", label: "จำนวนผู้ใช้", sortable: true },
        { key: "expired_date", label: "วันหมดอายุ", sortable: true },
        { key: "status", label: "สถานะ", sortable: true },
        { key: "actions", label: "การจัดการ", sortable: true },
      ];
      if (!this.isVisible) {
        fields = fields.filter(function (col) {
          return ["under_by"].indexOf(col.key) < 0;
        });
      }
      return fields;
    },
    tabTitle() {
      return [
        { key: "personal", name: "ข้อมูลส่วนตัว" },
        { key: "brance", name: "ข้อมูลร้าน" },
        { key: "other", name: "อื่นๆ" },
      ];
    },
    column() {
      let column = [
        {
          label: "วันที่อัพเดตข้อมูลล่าสุด",
          field: "last_updated",
        },
        {
          label: "รหัสร้าน",
          field: "shop_code",
        },
        {
          label: "รหัสตัวแทน",
          field: "dealer_id",
        },
        {
          label: "ชื่อเซลล์ที่ดูแล",
          field: "sale_name",
          dataFormat: (value) => {
            return value != null ? `${value}` : "-";
          },
        },
        {
          label: "แพ็กเกจ",
          field: "package",
        },
        {
          label: "ชื่อร้าน (ภาษาไทย)",
          field: "name",
        },
        {
          label: "ชื่อร้าน (ภาษาอังกฤษ)",
          field: "name_eng",
        },
        {
          label: "ชื่อเจ้าของร้าน (ภาษาไทย)",
          field: "owner_name",
        },
        {
          label: "ชื่อเจ้าของร้าน (ภาษาอังกฤษ)",
          field: "owner_name_eng",
        },
        {
          label: "เบอร์โทรร้าน",
          field: "tel",
        },
        {
          label: "เบอร์โทรส่วนตัว",
          field: "owner_tel",
        },
        {
          label: "อีเมล",
          field: "email",
        },
        {
          label: "ไอดีไลน์",
          field: "id_line",
        },
        {
          label: "วันเซ็นสัญญา",
          field: "contract_date",
        },
        {
          label: "วันที่หมดสัญญา",
          field: "expired_date",
        },
        {
          label: "เงื่อนไขพื้นที่ให้บริการ",
          field: "service_area_condition",
          dataFormat: (value) => {
            return serviceAreaBrance(value);
          },
        },
        {
          label: "จำนวนผู้ใช้",
          field: "num_of_user",
        },
        {
          label: "ที่อยู่ (ภาษาไทย)",
          field: "address",
        },
        {
          label: "ที่อยู่ (ภาษาอังกฤษ)",
          field: "address_eng",
        },
        {
          label: "พิกัดร้านละติจูด",
          field: "latitude_shop",
        },
        {
          label: "พิกัดร้านลองจิจูด",
          field: "longitude_shop",
        },
        {
          label: "วันและเวลาเปิดทำการ",
          field: "closed_day",
          dataFormat: (value) => {
            return this.setFormatClosedDay(value);
          },
        },
        {
          label: "สถานที่ใกล้ร้าน",
          field: "location_near",
          dataFormat: (value) => {
            return this.setFormatLocation(value);
          },
        },
        {
          label: "ลักษณะธุรกิจ",
          field: "nature_business",
        },
        {
          label: "พื้นที่ทั้งหมด (ตารางเมตร)",
          field: "area_shop",
        },
        {
          label: "พื้นที่ว่างเก็บของ",
          field: "storage_space",
          dataFormat: (value) => {
            return value == "YES"
              ? "มี"
              : value == "NO"
              ? "ไม่มีพื้นที่ว่าง"
              : "-";
          },
        },
        {
          label: "พื้นที่ว่างเก็บของ พื้นที่ว่าง (ตารางเมตร)",
          field: "storage_space_meters",
        },
        {
          label: "พื้นที่ว่างเก็บของ ความสูง (เมตร)",
          field: "storage_space_height",
          dataFormat: (value) => {
            return heightBrance(value);
          },
        },
        {
          label: "พื้นที่ว่างเก็บของให้เช่า",
          field: "storage_rent",
          dataFormat: (value) => {
            return rentBrance(value);
          },
        },
        {
          label: "พื้นที่ว่างเก็บของให้เช่า พื้นที่ว่าง (ตารางเมตร)",
          field: "storage_rent_meters",
        },
        {
          label: "พื้นที่ว่างเก็บของให้เช่า ความสูง (เมตร)",
          field: "storage_rent_height",
          dataFormat: (value) => {
            return heightBrance(value);
          },
        },
        {
          label: "พื้นที่โฆษณาให้เช่า (กว้าง X ยาว)",
          field: "billboard_rent",
          dataFormat: (value) => {
            return billboardBrance(value);
          },
        },
        {
          label: "พื้นที่ทำครัว",
          field: "kitchen_area",
          dataFormat: (value) => {
            return kitchenBrance(value);
          },
        },
        {
          label: "รูปพื้นที่หน้าร้าน",
          field: "image_front_area",
          dataFormat: (value) => {
            return this.setFormatImages(value);
          },
        },
        {
          label: "รูปสภาพแวดล้อมหน้าร้าน",
          field: "image_environment_area",
          dataFormat: (value) => {
            return this.setFormatImages(value);
          },
        },
        {
          label: "รูปพื้นที่ในร้าน",
          field: "image_shop_area",
          dataFormat: (value) => {
            return this.setFormatImages(value);
          },
        },
        {
          label: "รูปพื้นที่เก็บของ",
          field: "image_storage_space",
          dataFormat: (value) => {
            return this.setFormatImages(value);
          },
        },
        {
          label: "Tier ร้าน",
          field: "tier_shop",
          dataFormat: (value) => {
            return value != null ? `Tier ${value}` : "-";
          },
        },
        {
          label: "สนใจเปิดบริการเสริมอื่นๆ หรือไม่",
          field: "sell_service",
          dataFormat: (value) => {
            return sellServiceBrance(value);
          },
        },
        {
          label: "สนใจหรือไม่ หากมีบริการเสริมใหม่เข้ามา",
          field: "other_service",
          dataFormat: (value) => {
            return otherServiceBrance(value);
          },
        },
        {
          label: "กล้องวงจรปิด",
          field: "cctv",
          dataFormat: (value) => {
            return value == "YES"
              ? "มี และสามารถบันทึกย้อนหลังได้อย่างน้อย 30 วัน"
              : value == "NO"
              ? "ไม่มี"
              : "-";
          },
        },
        {
          label: "เครื่องสแกนบาร์โค้ด",
          field: "barcode_scanner",
          dataFormat: (value) => {
            return value == "YES" ? "มี" : value == "NO" ? "ไม่มี" : "-";
          },
        },
        {
          label: "ที่จอดรถ",
          field: "parking",
          dataFormat: (value) => {
            return value == "YES" ? "มี" : value == "NO" ? "ไม่มี" : "-";
          },
        },
        {
          label: "ระบบปฏิบัติการโทรศัพท์หน้าร้าน",
          field: "operating_system",
          dataFormat: (value) => {
            return this.setFormatOperatingSystem(value);
          },
        },
        {
          label: "สนใจให้ไปรษณีย์ไทยเข้ารับพัสดุหรือไม่",
          field: "pickup_thp",
          dataFormat: (value) => {
            return value == "YES"
              ? "สนใจ ให้ไปรษณีย์ไทยเข้ารับ"
              : value == "NO"
              ? "ไม่สนใจ ให้ไปรษณีย์ไทยเข้ารับ"
              : "-";
          },
        },
        {
          label: "ไปรษณีย์ไทยเข้ารับพัสดุกี่โมง",
          field: "time_pickup_thp",
          dataFormat: (value) => {
            return value != "-" ? `${value} น.` : "-";
          },
        },
        {
          label: "จำนวนพัสดุที่ส่งกับไปรษณีย์ต่อวัน",
          field: "nums_order_thp",
          dataFormat: (value) => {
            return value > 0 ? `${value} ชิ้น` : "-";
          },
        },
        {
          label: "เลือกรถไปรษณีย์เข้ารับ",
          field: "type_car_thp",
          dataFormat: (value) => {
            return typeCarTHPBrance(value);
          },
        },
      ];
      return column;
    },
  },
  methods: {
    resetFilter() {
      for (let key in this.filter) {
        if (key == "error") {
          this.filter[key] = false;
        } else {
          this.filter[key] = "";
        }
      }
    },
    changePage(i) {
      if (this.pagination.page == i) return;
      this.pagination.page = i;
      this.getDataBrance();
    },
    async getDataBranceExportExcel() {
      return await this.$http
        .post(
          API_URL + "/admin/shops",
          {
            filter: { ...this.filter },
            export_excel: true,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.showErrorModal(checkError.msg);
            return false;
          }
          return res.data.data.export_excel;
        });
    },
    getDataBrance() {
      this.busy = true;
      this.$http
        .post(
          API_URL + "/admin/shops",
          {
            filter: { ...this.filter },
            page: this.pagination.page,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.personal = res.data.data.personal;
          this.brances = res.data.data.brance;
          this.area = res.data.data.area;
          this.images = res.data.data.images;
          this.other = res.data.data.other;
          this.pagination.page = res.data.data.page;
          this.pagination.totalItem = res.data.data.totalItem;
          this.busy = false;
        });
    },
    getDataCouriers() {
      this.$http
        .get(API_URL + "/admin/couriers", {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        })
        .then((res) => {});
    },
    addBrance() {
      this.submittAdd = true;
      this.$v.$touch();
      if (this.$v.brance.$invalid) {
        return false;
      }
      this.$http
        .post(
          API_URL + "/admin/shop",
          {
            name: this.brance.name,
            owner_name: this.brance.owner_name,
            address: this.brance.address,
            state: this.brance.state,
            district: this.brance.district,
            province: this.brance.province,
            postcode: this.brance.postcode,
            tel: this.brance.tel,
            tax_shop: this.tax_shop,
            email: this.brance.email,
            password: this.brance.password,
          },
          {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          Object.keys(this.brance).forEach((key) => {
            this.brance[key] = "";
          });
          this.tax_shop = "";
          this.selected = "";
          this.select = "";
          this.$refs["addBrance"].hide();
          this.showSuccessModal("เพิ่มร้านค้าเสร็จสิ้น");
          this.getDataBrance();
        });
    },
    async statusChange(status, id) {
      status == 1 ? (status = 0) : (status = 1);
      await this.$http
        .put(
          API_URL + `/admin/shop/${id}/status`,
          {
            status: status,
          },
          {
            headers: { Token: localStorage.getItem("access_token") },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            if (checkError.msg == "กรุณาสมัครแพ็กเกจเพิ่ม") {
              let shopIndex = this.brances.findIndex((shop) => {
                return shop.id == id;
              });
              this.brances[shopIndex].status = 0;
            }
            return false;
          }
          this.showSuccessModal("แก้ไขสถานะร้านค้าเสร็จสิ้น");
          this.getDataBrance();
        });
    },
    async updateTierShop(tier_shop, id) {
      await this.$http
        .put(
          API_URL + `/admin/shop/${id}/tier`,
          {
            tier_shop: tier_shop,
          },
          {
            headers: { Token: localStorage.getItem("access_token") },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.showSuccessModal("แก้ไข Tier ร้านค้าเสร็จสิ้น");
          this.getDataBrance();
        });
    },
    deleteBrance() {
      let id = this.brance.idBrance;
      this.busy = true;
      this.$http
        .delete(API_URL + "/admin/shop/" + id, {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        })
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            this.busy = false;
            return false;
          }
          this.busy = false;
          this.showSuccessModal("ลบข้อมูลสำเร็จ");
          this.getDataBrance();
        });
    },
    checkStatusShop() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(API_URL + "/shop/noti", {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          })
          .then((res) => {
            let checkError = validatePop(res);
            if (!checkError.status) {
              if (checkError.notices == "token is expired") {
                this.$router.push("/logout");
              }
              this.showErrorModal(checkError.msg);
              this.busy = false;
              return false;
            }
            resolve(res);
          })
          .catch((error) => {
            this.showErrorModal("พบปัญหาการเชื่อมต่อ กรุณาติดต่อ...");
          });
      });
    },
    setFormatClosedDay(closed_day) {
      let res = [];
      if (closed_day.length > 1) {
        for (const [index, value] of Object.entries(closed_day)) {
          for (const [key, day] of Object.entries(value)) {
            res[index] = `${this.dayBrance(key)} ${day.open} - ${day.close} น.`;
          }
        }
      }
      return res.length > 1 ? res.join("\n") : "-";
    },
    setFormatLocation(location) {
      let res = [];
      if (location.length > 1) {
        for (const [index, value] of Object.entries(location)) {
          for (const [key, location] of Object.entries(value)) {
            res[index] = `${this.locationBrance(key)} ${location}`;
          }
        }
      }
      return res.length > 1 ? res.join("\n") : "-";
    },
    setFormatImages(images) {
      let res = [];
      if (images.length > 1) {
        for (const [index, value] of Object.entries(images)) {
          res[index] = `รูปที่ ${Number(index) + 1} - ${value}`;
        }
      }
      return res.length > 1 ? res.join("\n") : "-";
    },
    setFormatOperatingSystem(system) {
      let res = [];
      if (system.length > 1) {
        for (const [index, value] of Object.entries(system)) {
          if (typeof value === "object" && value !== null) {
            res[index] = value.other;
          } else {
            res[index] = operatingSystemBrance(value);
          }
        }
      }
      return res.length > 1 ? res.join("\n") : "-";
    },
    showComfirmModal(id) {
      this.brance.idBrance = id;
      this.$bvModal
        .msgBoxConfirm(`คุณต้องการจะลบร้านค้า `, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          //for P' OOOO
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteBrance();
          }
        });
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
  },
};
</script>
